import script from "./ReceitasPendencias.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceitasPendencias.vue?vue&type=script&setup=true&lang=js"

import "./ReceitasPendencias.vue?vue&type=style&index=0&id=8059288c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8059288c"]])

export default __exports__